module.exports = __webpack_public_path__ + "static/media/kms-image.0f9f5a4f.png";